import {isNil} from 'ramda';

import {GetArticleResponse, PatchArticleRequest} from '@dms/api/warehouse';

const MANUAL_STOCK_MANAGEMENT = 'MANUAL';

/**
 * Builds a full `patchArticle` body from an already loaded article, changing only the assigned
 * storage location. The article detail Locations section assigns a location the same way the
 * create-article dialog does (by persisting `storageLocationId`), but it lives outside the article
 * form, so it has to reconstruct the whole patch body from the loaded article instead of the form.
 *
 * Returns `null` when the article has no supplier yet, since `supplierId` is required by the patch
 * contract; the caller should treat that as a non-persistable state.
 */
export function getArticleStorageLocationPatchBody(
  article: GetArticleResponse,
  storageLocationId: string
): PatchArticleRequest['body'] | null {
  if (isNil(article.supplierId)) {
    return null;
  }

  const isManualStockManagement =
    article.stockManagement.stockManagementType === MANUAL_STOCK_MANAGEMENT;

  return {
    supplierId: article.supplierId,
    manufacturerId: article.manufacturerId,
    name: article.name,
    description: article.description,
    manufacturerNumber: article.manufacturerNumber,
    handlingUnit: article.handlingUnit,
    dispensingUnit: article.dispensingUnit,
    vatType: article.vatType,
    storageLocationId,
    treeFolder: {leafId: article.treeFolder.leafId},
    marketingCode: article.marketingCode,
    workItemGroupId: article.workItemGroupId,
    pricesSettings: article.pricesSettings,
    dispensingPrices: article.dispensingPrices,
    isOneTimeSale: article.isOneTimeSale,
    stockManagement: {
      stockManagementType: article.stockManagement.stockManagementType,
      stockManagementMinQuantity: isManualStockManagement
        ? undefined
        : article.stockManagement.stockManagementMinQuantity,
      stockManagementMaxQuantity: isManualStockManagement
        ? undefined
        : article.stockManagement.stockManagementMaxQuantity,
    },
  };
}
